"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mediaContainerDesignSchema = exports.BackgroundMediaSchema = exports.overlayBlending = void 0;
const yup = __importStar(require("yup"));
const schemaUtils_1 = require("../schemaUtils");
const Image_schema_1 = require("../image/Image.schema");
const Video_schema_1 = require("../video/Video.schema");
const Css_schema_1 = require("../css/Css.schema");
const mediaCommon_schema_1 = require("./mediaCommon.schema");
const scroll = [...['none', 'fixed', 'scroll', 'local', 'parallax']];
const blendMode = [
    ...[
        'normal',
        'multiply',
        'screen',
        'darken',
        'lighten',
        'overlay',
        'colorDodge',
        'colorBurn',
        'hardLight',
        'softLight',
        'difference',
        'exclusion',
        'hue',
        'saturation',
        'color',
        'luminosity',
    ],
];
const BackgroundTransforms = yup.object({
    scale: yup.number().min(0),
    opacity: yup.number().min(0).max(1),
});
exports.overlayBlending = yup.object({
    color: yup.string(),
    opacity: yup.number().min(0).max(1),
    contrast: yup.number().min(0).max(2),
    saturate: yup.number().min(0).max(2),
    blendMode: yup.mixed().oneOf(blendMode).default(blendMode[0]),
});
exports.BackgroundMediaSchema = schemaUtils_1.createDataSchema('BackgroundMedia', yup.object(Object.assign(Object.assign(Object.assign({ mediaRef: schemaUtils_1.createDataRef({
        Image: Image_schema_1.ImageSchema,
        Video: Video_schema_1.VideoSchema,
    }).notRequired(), mediaTransforms: BackgroundTransforms.notRequired(), overlayTransforms: BackgroundTransforms.notRequired(), imageOverlay: schemaUtils_1.createDataRef({ ImageOverlay: Image_schema_1.ImageSchema }).notRequired() }, mediaCommon_schema_1.alignmentSchemaField), mediaCommon_schema_1.fittingSchemaField), { scrollType: yup.mixed().oneOf(scroll).default(scroll[0]), showOverlayForMediaType: yup
        .mixed()
        .oneOf(['all', 'WixVideo', 'Image'])
        .default('WixVideo'), color: yup.string(), colorOpacity: yup.number(), colorOverlay: yup.string(), colorOverlayOpacity: yup.number(), overlayBlending: exports.overlayBlending.notRequired(), filterEffect: mediaCommon_schema_1.filterEffectSchemaObject.notRequired() })));
exports.mediaContainerDesignSchema = schemaUtils_1.createDataSchema('MediaContainerDesignData', yup.object({
    charas: yup.string().nullable(),
    background: schemaUtils_1.createDataRef({
        BackgroundMedia: exports.BackgroundMediaSchema,
    }).nullable(),
    dataChangeBehaviors: yup
        .array()
        .of(yup.object({
        trigger: yup.string(),
        type: yup.string(),
        part: yup.string(),
        name: yup.string(),
        params: yup.object({
            duration: yup.number(),
        }),
    }))
        .nullable(),
    cssStyle: Css_schema_1.cssStyle.default(undefined),
    themeMappings: yup.object(),
}));
//# sourceMappingURL=Media.schema.js.map